import api from "../../services/api";

// uso = "atribuir": só as que o usuário pode pôr num lead; sem uso, todas as que ele vê.
const useTags = (uso) => {
	const findAll = async () => {
        const { data } = await api.get("/tags", { params: uso ? { uso } : undefined });
        return data;
    }

	return { findAll };
};

export default useTags;
